import React, { useContext } from 'react';
import { Col, Row } from '@firsttable/web-components/atoms';
import { ContainerContent, RowHead } from '@firsttable/web-components/molecules';
import ContactForm from '../organisms/Forms/DynamicUserForm';
import imgFork from '../organisms/ContactUs/fork.svg?url';
import parseHtml from '../../lib/parseHtml';
import SEO from '../SEO';
import SilverstripeContext from '../context/Silverstripe';

const UserDefinedFormTwoColumnPage = () => {
  const { page } = useContext(SilverstripeContext);
  return (
    <>
      <ContainerContent>
        <SEO
          id={page.id}
          title={page.metaTitleFormatted}
          description={page.metaTitleFormatted}
          ogImage={page.ogImage}
          metaTags={page.metaTags}
          slug={page.slug}
        />
        <RowHead title={page.title} />
        <Row gap={[null, 120, 164]} flexDirection={['column-reverse', 'row']}>
          <Col width={[1, 1 / 2]} pt={[null, 20]}>
            {parseHtml(page.sidebarContent)}
            <ContactForm
              id="ContactForm"
              formData={page.userForm}
              formFields={page.userForm.formFields}
              data-testid="contact__form"
            />
          </Col>
          <Col width={[1, 1 / 2]} line hideLineOnMobile pt={[null, 20]} icon={imgFork}>
            {parseHtml(page.content)}
          </Col>
        </Row>
      </ContainerContent>
    </>
  );
};

export default UserDefinedFormTwoColumnPage;
